import React, { memo, useContext } from 'react'
import { CircleTickMinor } from '@shopify/polaris-icons'
import { TeamMemberStatusChip } from './TeamMemberStatusChip'
import { TeamMembersTableContext } from '../tables/team-members-table/TeamMembersTable.context'
import { TeamMemberStatus } from 'src/constants/team/team-members/enums'
import { TableSelect } from 'src/components/shared/table/TableSelect'

const statuses = [
  {
    value: TeamMemberStatus.Active,
    component: <TeamMemberStatusChip status={TeamMemberStatus.Active} />,
  },
  {
    value: TeamMemberStatus.Deactivated,
    component: <TeamMemberStatusChip status={TeamMemberStatus.Deactivated} />,
  },
]

const TeamMemberStatusSelectComponent = () => {
  const { statusFilter, setStatusFilter } = useContext(TeamMembersTableContext)

  return (
    <TableSelect<TeamMemberStatus>
      title="Status"
      selectedValues={statusFilter}
      icon={<CircleTickMinor width={20} />}
      options={statuses}
      onSelect={setStatusFilter}
    />
  )
}

export const TeamMemberStatusSelect = memo(TeamMemberStatusSelectComponent)
